import { render, staticRenderFns } from "./UploadByResolution.vue?vue&type=template&id=8b7c095c&scoped=true&"
import script from "./UploadByResolution.vue?vue&type=script&lang=js&"
export * from "./UploadByResolution.vue?vue&type=script&lang=js&"
import style0 from "./UploadByResolution.vue?vue&type=style&index=0&id=8b7c095c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7c095c",
  null
  
)

export default component.exports